import { render, staticRenderFns } from "./CreateList.vue?vue&type=template&id=6f82b0d4&scoped=true&"
import script from "./CreateList.vue?vue&type=script&lang=js&"
export * from "./CreateList.vue?vue&type=script&lang=js&"
import style0 from "./CreateList.vue?vue&type=style&index=0&id=6f82b0d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f82b0d4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Users/pc/Documents/Programs/Vue/top-ten-naija/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
import { VAutocomplete } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCheckbox } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VRadio } from 'vuetify/lib'
import { VRadioGroup } from 'vuetify/lib'
import { VRow } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VTextarea } from 'vuetify/lib'
installComponents(component, {VAlert,VAutocomplete,VBtn,VCard,VCardActions,VCardText,VCheckbox,VContainer,VDialog,VFlex,VForm,VIcon,VLayout,VRadio,VRadioGroup,VRow,VSpacer,VTextField,VTextarea})
